import { apiSlice } from "../api/apiSlice";

export const quizzesApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getQuizzes: builder.query({
      query: () => ({
        url: "/quizzes",
        method: "GET",
      }),
    }),
    getQuizzesByVedioId: builder.query({
      query: (id) => ({
        url: `/quizzes?video_id_like=${id}`,
        method: "GET",
      }),
    }),
    getQuiz: builder.query({
      query: (id) => ({
        url: `/quizzes/${id}`,
        method: "GET",
      }),
    }),

    deleteQuiz: builder.mutation({
      query: (id) => ({
        url: `/quizzes/${id}`,
        method: "DELETE",
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data: deletedQuiz } = await queryFulfilled;
          // update catch pessimestically start
          dispatch(
            apiSlice.util.updateQueryData("getQuizzes", undefined, (draft) => {
              return draft.filter((quiz) => quiz.id !== arg);
            })
          );

          // update catch pessimestically end
        } catch (error) {}
      },
    }),
    editQuiz: builder.mutation({
      query: ({ id, data }) => ({
        url: `/quizzes/${id}`,
        method: "PATCH",
        body: data,
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data: editedQuiz } = await queryFulfilled;
          // update catch pessimestically start
          dispatch(
            apiSlice.util.updateQueryData("getQuizzes", undefined, (draft) => {
              const draftQuiz = draft.find((quiz) => quiz.id == editedQuiz.id);
              draftQuiz.question = editedQuiz.question;
              draftQuiz.video_id = editedQuiz.video_id;
              draftQuiz.video_title = editedQuiz.video_title;
              draftQuiz.options = editedQuiz.options;
            })
          );

          // update catch pessimestically end
        } catch (error) {}
      },
    }),
    addQuiz: builder.mutation({
      query: (data) => ({
        url: `/quizzes`,
        method: "POST",
        body: data,
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data: addedQuiz } = await queryFulfilled;
          // update catch pessimestically start
          dispatch(
            apiSlice.util.updateQueryData("getQuizzes", undefined, (draft) => {
              draft.push(addedQuiz);
            })
          );

          // update catch pessimestically end
        } catch (error) {}
      },
    }),

    getVideoQuizzes: builder.query({
      query: (id) => ({
        url: `/quizzes?video_id_like=${id}`,
        method: "GET",
      }),
    }),

    submitQuiz: builder.mutation({
      query: (data) => ({
        url: `/quizMark`,
        method: "POST",
        body: data,
      }),

      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data: UpdatedQuizMark } = await queryFulfilled;
          // update catch pessimestically start
          dispatch(
            apiSlice.util.updateQueryData(
              "getQuizMark",
              {
                studentId: arg?.student_id,
                videoId: arg?.video_id,
              },
              (draft) => {
                draft.push(UpdatedQuizMark);
              }
            )
          );

          // update catch pessimestically end
        } catch (error) {}
      },
    }),

    getQuizMark: builder.query({
      query: ({ studentId, videoId }) => ({
        url: `/quizMark?student_id_like=${studentId}&video_id_like=${videoId}`,
        method: "GET",
      }),
    }),
    getQuizMarks: builder.query({
      query: () => ({
        url: `/quizMark`,
        method: "GET",
      }),
    }),
    getSubmittedQuiz: builder.query({
      query: (studentId) => ({
        url: `/quizMark?student_id_like=${studentId}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useSubmitQuizMutation,
  useGetQuizzesByVedioIdQuery,
  useGetQuizzesQuery,
  useGetVideoQuizzesQuery,
  useGetQuizMarkQuery,
  useGetSubmittedQuizQuery,
  useGetQuizMarksQuery,
  useDeleteQuizMutation,
  useEditQuizMutation,
  useGetQuizQuery,
  useAddQuizMutation,
} = quizzesApi;
